module.exports = __webpack_public_path__ + "static/media/DC_Logo_Icon.b733aad9.png";